<template>
  <div class="imprint site">
    <h1>Impressum</h1>
    <div class="imp-section" v-for="(section, index) in imprint" :key="index" v-scroll-reveal>
      <h2>{{ section.title }}</h2>
      <p v-html="section.content">{{ section.content }}</p>
      <div
        class="sub-imp-section"
        v-for="(sub, index) in section.subSections"
        :key="index"
        :id="sub.title"
      >
        <h3>{{ sub.title }}</h3>
        <p v-html="sub.content">{{ sub.content }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  title: "Impressum - Ocular",
  computed: {
    imprint() {
      return this.$store.state.imprint;
    },
    subSection() {
      return this.imprint.subSection;
    },
  },
};
</script>

<style lang="scss" scoped>
.imprint {
  h2 {
    margin-bottom: 2rem;
  }
  button {
    color: red;
  }
  .imp-section {
    margin-bottom: 4rem;
    border-radius: 10px;
    text-align: left;
    background-color: #ebebeb;
    padding: 3vw 5vw 3vw 5vw;
    .sub-imp-section {
      padding: 7rem 0 0 0;
      h3 {
        margin-bottom: 1.5rem;
      }
    }
  }
}
@media only screen and (max-width: 1024px) {
  .imprint{
    .imp-section{
      padding: 7vw;
    }
  }
}
</style>
